import { render, staticRenderFns } from "./RecruitmentPost.vue?vue&type=template&id=3821df84&scoped=true&"
import script from "./RecruitmentPost.vue?vue&type=script&lang=js&"
export * from "./RecruitmentPost.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentPost.vue?vue&type=style&index=0&id=3821df84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821df84",
  null
  
)

export default component.exports